module.exports = __webpack_public_path__ + "img/perks_C STH Gift.420f06c8.jpg";